export default {
  CAR_MODELS: 'car_models',
  CAR_COLORS: 'car_colors',
  CAR_CLASSES: 'car_classes',
  BOOKING_LOCATION_CLASSES: 'booking_location_classes',
  BOOKING_COMMENTS: 'booking_comments',
  BOOKING_DRIVER_STATES: 'booking_driver_states',
  PAYMENT_WAYS: 'payment_ways',
  LANG_VLS: 'lang_vls',
} as const